// Block D (2026-10-08): the compact health score on a CRM card and in the drawer, on tokens.
// A dot in the score's pastel, the score and its word: the word carries the meaning, not the colour.
import React from 'react';
import { scoreTone } from './ClientHealthScore';

function timeAgo(dt) {
  if (!dt) return null;
  const secs = Math.floor((Date.now() - new Date(dt)) / 1000);
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)} minutes ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)} hours ago`;
  return `${Math.floor(secs / 86400)} days ago`;
}

function word(score) {
  if (score == null) return 'No data';
  if (score >= 90) return 'Excellent';
  if (score >= 70) return 'Good';
  if (score >= 40) return 'Fair';
  return 'At risk';
}

export default function HealthScoreBadge({ score, scoredAt, ...rest }) {
  const ago = timeAgo(scoredAt);
  return (
    <span className="crm-badge" title={ago ? `Last calculated: ${ago}` : 'Score not yet calculated'} {...rest}>
      <span className="crm-badge__dot" style={{ '--ui-bg': `var(--${scoreTone(score ?? null)})` }} aria-hidden="true" />
      {score != null && <span>{score}</span>}
      {word(score ?? null)}
    </span>
  );
}
